


import React, { lazy, Suspense, useEffect, useState } from 'react'
import {
    BrowserRouter as Router,
    Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";
// import '../mygloble.css'

import { Spinner } from '@material-tailwind/react';
import { ToastContainer, toast } from 'react-toastify';

const  Mainhome= lazy(() => import('../Pages/Home/Mainhome'));
const  Headerweb= lazy(() => import('../Components/Headerweb'));
const  Signupforweb= lazy(() => import('../Pages/Signup/Signupforweb'));
const  Mainpricingweb= lazy(() => import('../Pages/Pricing/Mainpricingweb'));
const  Footerweb= lazy(() => import('../Components/Footerweb'));
const  Privacypoliciy= lazy(() => import('../Pages/Privacypolicy'));
const Tandc = lazy(() => import('../Pages/Tandc'));
const Aboutus = lazy(() => import('../Pages/Aboutus'));
const  Thankyou= lazy(() => import('../Pages/Thankyou'));
const  Contactus= lazy(() => import('../Pages/Contactus'));
const Productandsolution = lazy(() => import('../Pages/Productandsolution'));
const Services = lazy(() => import('../Pages/Services'));
const Trackingpage = lazy(() => import('../Pages/Productsolution/Trackingpage'));
const Powerfulltools = lazy(() => import('../Pages/Productsolution/Powerfulltools'));
const AntiFraudpage = lazy(() => import('../Pages/Productsolution/AntiFraudpage'));
const Offermanagmentpage = lazy(() => import('../Pages/Productsolution/Offermanagmentpage'));
const  Reposrtsmanagpage= lazy(() => import('../Pages/Productsolution/Reposrtsmanagpage'));
const Refundpolicy = lazy(() => import('../Pages/Refundpolicy'));






const Mainrouteweb = () => {

    document.title = `OfferBorn Affordable Performance Marketing Platform`







    //   useEffect(()=>{
    //     callForCheckPlatform()
    //     token && checkvalidtoken()

    //   },[])




    //   const callForCheckPlatform =async ()=>{
    //     setloading(true)
    //     await gpeapi.get(`/${platformurl}/checkagencyplatform`).then((res)=>setisvalid(res.data.success)).catch((e)=>setisvalid(e?.response?.data?.success))
    //     setloading(false)
    //   }




    //   const checkvalidtoken = ()=>{
    //     gpeapi.get(`/${platformurl}/checkagencytoken`,{headers:{
    //       "Authorization":`Beaer ${token}`
    //   }}).then((res)=>{
    //     if(res.data.success){
    //       setinfo(res.data.user)
    //        localStorage.setItem('userInfo', JSON.stringify(res.data.user));

    //        if(res.data.user?.extendplanended){
    //         toast.warning('Your Plan Ended Please Purchase a Plan to Continue Services')
    //        }

    //        if(res.data.user?.planended){
    //         toast.warning('Your Plan Ended Please Purchase a Plan to Continue Services')
    //        }



    //     }else{
    //       localStorage.clear()
    //       window.location.reload('')
    //     }
    //   })
    //   // console.log('runnn')
    //   }

    //   const menus = [
    //     { name: "dashboard", link: `/${platformurl}/agency/dashboard`, icon: MdOutlineDashboard },
    //     {
    //       name: "campaigns", link: "/", icon: MdCampaign, submenu: [
    //         { name: "all campaigns", link: `/${platformurl}/agency/campaigns` },
    //         { name: "create campaign", link: `/${platformurl}/agency/createcamp` },

    //       ]
    //     },
    //     {
    //       name: "reports", link: "/", icon: IoAnalyticsSharp, submenu: [
    //         { name: "campaigns report", link: `/${platformurl}/agency/performancerepo` },
    //         { name: "daily report", link: `/${platformurl}/agency/dailyreport` },
    //         { name: "publishers report", link: `/${platformurl}/agency/publisherreport` },
    //         { name: "advertisers report", link: `/${platformurl}/agency/advertiserreport` },
    //         { name: "conversion report", link: `/${platformurl}/agency/conversionreport` },
    //         // { name: "clicks report", link: "/" },
    //         // { name: "sub-id reports", link: "/" },
    //       ]
    //     },
    //     { name: "publishers", link: "/", icon: TbFriends,submenu:[
    //       { name: "all publishers", link: `/${platformurl}/agency/publishers` },


    //     ] },
    //     { name: "advertisers", link: "/", icon: FaHandsHelping,submenu:[
    //       { name: "all advertisers", link: `/${platformurl}/agency/advertisers` },


    //     ]  },

    //     { name: "account", link: `/${platformurl}/agency/account`, icon: CgProfile 
    //   },

    //   { name: "billing", link: `/${platformurl}/agency/billing`, icon: MdPayment 
    //   },
    //     // { name: "Cart", link: "/", icon: FiShoppingCart },
    //     // { name: "Billing", link: "/", icon: TbCreditCard },
    //     // { name: "Setting", link: "/", icon: RiSettings4Line },
    //   ];

    // console.log(info)

    const handlewhstappclick = ()=>{
        const whatsappUrl = `https://api.whatsapp.com/send?phone=918516069206&text=Hello OfferBorn Team`;
        window.open(whatsappUrl, '_blank').focus();
      }


    return (


    <>

        {/* <Router> */}

        <Headerweb />
        <img onClick={handlewhstappclick} style={{position:'fixed',bottom:10,right:10,zIndex:10,cursor:'pointer'}} width={70} src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/1022px-WhatsApp.svg.png'/>
        {/* <Headerwebnew/> */}
        <Routes>


            {/* <Route path='/' element={<Mainhome />} /> */}
            <Route path='/*' element={<Mainhome />} />
            <Route path='/signup' element={<Suspense><Signupforweb /></Suspense>} />
            <Route path='/price' element={<Mainpricingweb />} />
            <Route path='/privacy-policy' element={<Privacypoliciy />} />
            <Route path='/terms-&-conditions' element={<Tandc />} />
            <Route path='/refund-policy' element={<Refundpolicy />} />
            <Route path='/about' element={<Aboutus />} />
            <Route path='/contact' element={<Contactus />} />
            <Route path='/solution' element={<Productandsolution />} />
            <Route path='/service' element={<Services />} />
            <Route path='/thankyou' element={<Thankyou />} />


            <Route path='/tracking' element={<Trackingpage />} />
            <Route path='/powerful-tool' element={<Powerfulltools />} />
            <Route path='/anti-fraud' element={<AntiFraudpage />} />
            <Route path='/offer-management' element={<Offermanagmentpage />} />
            <Route path='/reports-management' element={<Reposrtsmanagpage />} />
            {/* <Route path='/privacy-policy' element={<Privacypoliciy />} /> */}

            {/* <Route path='*' element={<Signupforweb/>}/> */}




        </Routes>
        <Footerweb />


        {/* </Router> */}











    </>








)
}

export default Mainrouteweb